import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

interface BlurWrapperProps {
    children: ReactNode;
}

const BlurWrapper: React.FC<BlurWrapperProps> = ({ children }) => {
    return (
        <>
            {/* 背景遮罩 */}
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)', // 半透明黑色
                    backdropFilter: 'blur(4px)', // 模糊效果
                    zIndex: 11,
                }}
            />
            {/* 包含子元件，置於遮罩之上 */}
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 12,
                }}
            >
                {children}
            </Box>
        </>
    );
};

export default BlurWrapper;
